class EventTypes {
    static Invalid = 0;
    static PlayAsset = 1;
    static SpotBlock =  2;
    static ETM = 3;
    static Comment = 6;
    static NoteEvent = 11;
    static TrafficLoadPOS = 12;
    static SequencerStart = 13;
    static BlockFillPOS = 14;
    static MusicFillPos = 15;
    static ExecuteCommand = 16;
    static LastEventInCustomShow = 17;
    static LocalBreak = 18;
    static EdgeAction = 19;
	static DVTBlock = 20;
	static Rejoin = 21;
    static PlaylistHeader = 100;

	static getArray() {
		return Object.keys(this).map((t, i) => {
			return {
				name: t.split(/(?<=[a-z])(?=[A-Z])/).join(" "),
				type: Object.values(this)[i]
			}
		});
	}

	static getName(type) {
		return this.getArray().find(t => t.type === type)?.name;
	}
}

export default EventTypes;